(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-wall"] && !Shopify.designMode) return;
  try {
    
  // Facade pattern: the Streamable iframe is only created on demand, so a homepage
  // with several clips costs N poster images at rest instead of N video players.
  // Delegated from document so it survives Theme Editor section re-renders.
  if (!window.__violetVibesVideoWallBound) {
    window.__violetVibesVideoWallBound = true;

    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-video-wall-play]');
      if (!trigger) return;

      const frame = trigger.closest('[data-video-wall-frame]');
      const videoId = frame && frame.dataset.videoId;
      if (!frame || !videoId) return;

      const iframe = document.createElement('iframe');
      iframe.src = `https://streamable.com/e/${encodeURIComponent(videoId)}?autoplay=1`;
      iframe.allow = 'autoplay; fullscreen';
      iframe.allowFullscreen = true;
      iframe.loading = 'lazy';
      iframe.title = trigger.getAttribute('aria-label') || 'Video';

      frame.replaceChildren(iframe);
    });
  }

  } catch(e) { console.error(e); }
})();
})();
